import { useEffect } from "react";

/**
 * ToastBelowTitle - puts each toast just under the screen's title, wherever
 * that title is (V19.04, live test 19.03 item 12).
 *
 * Toasts covered the title in V18.99 at the top edge, and again in V19.03 at
 * a fixed 76 px: the screens do not share one header height. Reminders has
 * its title in a 72 px bar, the main tabs put theirs about 130 px down, a
 * list's own name sits somewhere else again. Any one number is wrong for
 * some screen, so the number is measured: when a toast appears, the lowest
 * edge of the title (the first h1, or h2 when a screen has no h1, in the top
 * half of the window) decides where the toast goes. With no title in view
 * the toast keeps its normal place near the top. It never covers a bottom
 * bar, which is why the toast did not simply move to the bottom.
 */
const GAP = 8;

function titleBottom() {
  const limit = window.innerHeight * 0.5;
  // A screen can mark what must stay readable under its title - Meals marks
  // the week's dates (V19.06, live test 19.05 item 5: "No meals to copy..."
  // sat on "12 Oct - 18 Oct"). The lowest marked line in view wins.
  let marked = null;
  for (const el of document.querySelectorAll("[data-toast-anchor]")) {
    const r = el.getBoundingClientRect();
    if (r.height > 0 && r.bottom > 0 && r.top < limit) marked = Math.max(marked ?? 0, Math.round(r.bottom));
  }
  if (marked != null) return marked;
  for (const sel of ["h1", "h2"]) {
    for (const el of document.querySelectorAll(sel)) {
      if (el.closest("[data-sonner-toaster]")) continue;
      const r = el.getBoundingClientRect();
      if (r.height > 0 && r.bottom > 0 && r.top < limit) return Math.round(r.bottom);
    }
  }
  return null;
}

export default function ToastBelowTitle() {
  useEffect(() => {
    const place = () => {
      const toaster = document.querySelector("[data-sonner-toaster]");
      if (!toaster || !toaster.querySelector("[data-sonner-toast]")) return;
      const bottom = titleBottom();
      if (bottom == null) {
        toaster.style.removeProperty("--offset-top");
        toaster.style.removeProperty("--mobile-offset-top");
        return;
      }
      const top = `${bottom + GAP}px`;
      toaster.style.setProperty("--offset-top", top);
      toaster.style.setProperty("--mobile-offset-top", top);
    };
    const obs = new MutationObserver(place);
    obs.observe(document.body, { childList: true, subtree: true });
    return () => obs.disconnect();
  }, []);
  return null;
}
